import { Page, PageHeader } from 'components';
import DistributorsProvider from './DistributorsContext';
import { Results, Filters } from './components';


let VitecUsers = () => {
    return (
        <Page >
            <DistributorsProvider>
                <PageHeader
                    pageTitle="Distributor users"
                    addNewUrl="/admin/distributor/addnew"
                />
                <Filters />
                <Results />
            </DistributorsProvider>
        </Page>
    )
}

export default VitecUsers;